import { render, staticRenderFns } from "./QuoteDeclined.vue?vue&type=template&id=19217878&"
import script from "./QuoteDeclined.vue?vue&type=script&lang=js&"
export * from "./QuoteDeclined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19217878')) {
      api.createRecord('19217878', component.options)
    } else {
      api.reload('19217878', component.options)
    }
    module.hot.accept("./QuoteDeclined.vue?vue&type=template&id=19217878&", function () {
      api.rerender('19217878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/reservationAdministration/QuoteDeclined.vue"
export default component.exports